import React from "react";
import { Loader2 } from "lucide-react";

export function Panel({ title, children, className }) {
  return (
    <section className={className ? `panel ${className}` : "panel"}>
      <div className="panel-head"><h3>{title}</h3></div>
      {children}
    </section>
  );
}

// Phase 3 — standard loading states. Use these instead of one-off
// "Loading…" strings or inline Loader2 calls so the spinner feel is
// consistent across views.
//
//   <Loading />                              — full block with spinner + text
//   <Loading label="Fetching stats…" />     — custom text
//   <Loading size="lg" />                    — bigger spinner
//   <LoadingInline />                        — inline (e.g. inside a button)
//   <LoadingInline label="Saving…" />        — inline + text
export function Loading({ label = "Loading…", size = "md" }) {
  const px = size === "sm" ? 14 : size === "lg" ? 28 : 18;
  const padding = size === "sm" ? "12px 0" : size === "lg" ? "32px 0" : "20px 0";
  return (
    <div
      className="loading"
      role="status"
      aria-busy="true"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding,
        color: "var(--muted)",
        fontSize: 13
      }}
    >
      <Loader2 size={px} className="spin" />
      {label && <span>{label}</span>}
    </div>
  );
}

export function LoadingInline({ label = null, size = 12 }) {
  return (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "inherit" }}
      role="status"
      aria-busy="true"
    >
      <Loader2 size={size} className="spin" />
      {label && <span>{label}</span>}
    </span>
  );
}

export function Row({ title, sub, tag }) {
  return (
    <div className="row">
      <div><strong>{title}</strong><span>{sub}</span></div>
      <em>{tag}</em>
    </div>
  );
}

export function Card({ title, text, tag, footer }) {
  return (
    <div className="card">
      <span className="tag">{tag}</span>
      <h3>{title}</h3>
      <p>{text}</p>
      <small>{footer}</small>
    </div>
  );
}
